import 'babel-polyfill'

import React from 'react'
import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'

import Auth from './actions/auth'
import App from './app'
import { ConnectedSwitch } from './components/auth'
import LoginGSMPage from './pages/login-gsm-page'
import RouteMapService from './services/route-map'
import ModuleLazyLoaderService from './services/module-lazy-loader'
import configureStore, { history } from './store'

require('./include/scss/index.scss')

const store = configureStore()

const render = (modules) => {

    const appElement = document.getElementById('app')
    const ReactDOM = modules['react-dom']

    const appRoutes = RouteMapService.generateRoutes(RouteMapService.apps)
    const utilRoutes = RouteMapService.generateRoutes(RouteMapService.util)

    const routes = (
        <ConnectedSwitch>
            <Route component={LoginGSMPage} exact path="/" />
            {appRoutes}
            {utilRoutes}
        </ConnectedSwitch>
    )

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App>
                    {routes}
                </App>
            </ConnectedRouter>
        </Provider>,
        appElement
    )
}

const modulesToLoad = [
    'react-dom'
]


/**
 * Entry point for initial load
 */
ModuleLazyLoaderService.load(modulesToLoad)
    .catch((error) => {
        /* eslint-disable no-console */
        console.log('Unable to lazy load core modules: ', error.stack)
        /* eslint-enable no-console */
    })
    .then((modules) => {
        const auth = new Auth()
        return store.dispatch(auth.reload())
            .then(() => render(modules))
    })
    .catch((error) => {
        /* eslint-disable no-console */
        console.log('Page load failed: ', error.stack)
        /* eslint-enable no-console */
    })




// WEBPACK FOOTER //
// src/index.js